import React from "react";
import { FORWHOM } from "../../data";
import SectionHead from "./SectionHead";
import { Check, X } from "lucide-react";

export default function ForWhom() {
  return (
    <section className="sec">
      <div className="mx-auto max-w-[1080px] px-4 lg:max-w-[1440px] lg:px-12">
        <SectionHead index={FORWHOM.index} title="Per chi è, e per chi non è" />

        <div className="grid gap-5 md:grid-cols-2 mt-10">
          <div className="panel p-7" style={{ borderColor: "rgba(46,107,255,0.55)" }}>
            <h3 className="display" style={{ fontSize: "1.4rem" }}>{FORWHOM.forYou.title}</h3>
            <ul className="mt-5" style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {FORWHOM.forYou.items.map((it, i) => (
                <li key={i} className="flex gap-3 py-2.5">
                  <Check size={18} className="blue mt-1 shrink-0" strokeWidth={2.5} />
                  <span style={{ fontSize: "1rem", color: "var(--ink)" }}>{it}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="panel p-7">
            <h3 className="display" style={{ fontSize: "1.4rem", color: "var(--muted)" }}>{FORWHOM.notForYou.title}</h3>
            <ul className="mt-5" style={{ listStyle: "none", padding: 0, margin: 0 }}>
              {FORWHOM.notForYou.items.map((it, i) => (
                <li key={i} className="flex gap-3 py-2.5">
                  <X size={18} className="mt-1 shrink-0" style={{ color: "var(--red)" }} strokeWidth={2.5} />
                  <span style={{ fontSize: "1rem" }}>{it}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
